export default (state = {
    variantsIndexes: [],
    images: [],
    color: [],
    variants: [],
}, action) => {
    switch (action.type) {
        case 'UPDATE_PRODUCT_VALUE' :
            return {
                ...state,
                [action.name]: action.value
            };
        case 'UPDATE_PRODUCT_VARIANT_INDEXES' :
            return {
                ...state,
                variantsIndexes: action.variants
            };
        case 'UPDATE_PRODUCT_FROM_BULK' :
            return {
                ...state,
                ...action.results
            };

        default:
            return state;
    }
};
